import React from "react";
import ReactMarkdown from "react-markdown";

export const normalizeMarkdownLineBreaks = (value) => {
  if (typeof value !== "string") {
    return value;
  }

  return value.replace(/<br\s*\/?>/gi, "  \n");
};

const QuizMarkdown = ({ children, ...props }) =>
  React.createElement(
    ReactMarkdown,
    props,
    normalizeMarkdownLineBreaks(children)
  );

export default QuizMarkdown;
